export enum DynamicSettingsFieldTypes {
  CHECKBOX = "checkbox",
  DATE = "date",
  NUMBER = "number",
  PASSWORD = "password",
  RADIO = "radio",
  SELECT = "select",
  SLIDER = "slider",
  SWITCH = "switch",
  TEXT = "text",
  TEXTAREA = "textarea",
  MULTIPLE = "multiple"
}

export enum HelperTextTypes {
  INFO = "info",
  TOOLTIP = "tooltip"
}
